/* @flow */

import * as React from 'react';
import classnames from 'classnames';

import FAIcon from 'common/components/FAIcon';

import styles from './Checklist.scss';

export function List(props: { children: React.Node, className?: string }) {
  return (
    <ul className={classnames(styles.checklist, props.className)}>
      {props.children}
    </ul>
  );
}

type ItemProps = {
  children: React.Node,
  className?: string,
  type?: 'success' | 'primary'
};

export function Item(props: ItemProps) {
  const itemClassName = classnames(styles.item, props.className);

  const type = props.type || 'success';
  const iconClassName =
    type === 'success' ? styles.checkSuccess : styles.checkPrimary;

  return (
    <li className={itemClassName}>
      <FAIcon name="check" className={iconClassName} />
      {props.children}
    </li>
  );
}
